import Axios from 'axios'
import * as React from 'react'
import {AlphaPicker, RGBColor, SliderPicker} from 'react-color'
import {connect} from 'react-redux'
import {v4 as uuidv4} from 'uuid'
import {Collapsible} from '../../core/components/Controls/Collapsible/Collapsible'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {CoordinateSystem} from '../../core/enums/CoordinateSystem'
import {ViewSchemaType} from '../../core/enums/ViewSchemaType'
import {ISourcesDispatcher} from '../../core/interfaces/dispatchers'
import {ISourceDescription, ISourceDescriptions} from '../../core/interfaces/models'
import {IFeatureLayerInfos} from '../../core/interfaces/reducers'
import {Feature} from '../../core/models'
import {ServiceHub} from '../../core/ServiceHub'
import {appSourcesDispatcher} from '../../dispatchers/appSourcesDispatcher'
import {getPlanName} from '../../helpers/regHelper'
import {IAppStore, IAppUser} from '../../interfaces/reducers'
import appConfig from '../../reducers/appConfig'
import {CsSelectorLite} from '../../core/components/Controls/CsSelector'
import {LocationSelector} from '../App/LocationSelector'
interface State {
  loading: boolean
  selectedSettlemet?: Feature
  selectedLocation?: Feature
  locationPlans: Feature[]
  selectedPlan?: Feature
  selectedPlanType: 'edited' | 'non-edited'
  addChangesOnly: boolean
  selectedPlanIsCurrent: boolean
  exportedPlan: string
  exception: string
  success: string
  exportCs: CoordinateSystem
  parcels: {
    strokeColor: RGBColor
    fillColor: RGBColor
    textColor: RGBColor
    layerName: string
    open: boolean
  }
  quarter: {
    strokeColor: RGBColor
    fillColor: RGBColor
    textColor: RGBColor
    layerName: string
    open: boolean
  }
  regPoint: {
    strokeColor: RGBColor
    layerName: string
    open: boolean
  }
  regLine: {
    strokeColor: RGBColor
    layerName: string
    open: boolean
  }
  regOsLine: {
    strokeColor: RGBColor
    layerName: string
    open: boolean
  }
}

interface DispatchProps extends ISourcesDispatcher {}

interface ParentProps {}

interface OwnProps {
  layerInfos: IFeatureLayerInfos
  user?: IAppUser
}

type Props = DispatchProps & OwnProps & ParentProps
class RegHistoryClass extends React.Component<Props, State> {
  confirmDeleteMsg = 'Моля, потвърдете изтриването като натиснете пак'
  confirmDeleteLocMsg = 'Потвърдете изтриването като натиснете пак'
  confirmDeletePlanMsg = 'Потвърдете изтриването като натиснете отново'
  constructor(props: Props) {
    super(props)
    this.state = {
      loading: false,
      success: '',
      exportCs: CoordinateSystem.BG2005CAD,
      locationPlans: [],
      exportedPlan: '',
      exception: '',
      parcels: {
        strokeColor: {r: 255, g: 179, b: 0, a: 1},
        fillColor: {r: 255, g: 255, b: 0, a: 0},
        textColor: {r: 255, g: 120, b: 0, a: 1},
        layerName: 'УПИ',
        open: false
      },
      quarter: {
        strokeColor: {r: 255, g: 179, b: 0, a: 1},
        fillColor: {r: 255, g: 255, b: 0, a: 0},
        textColor: {r: 255, g: 120, b: 0, a: 1},
        layerName: 'Квартали',
        open: false
      },
      regPoint: {
        strokeColor: {r: 255, g: 179, b: 0, a: 1},
        layerName: 'Осова точка',
        open: false
      },
      regLine: {
        strokeColor: {r: 255, g: 179, b: 0, a: 1},
        layerName: 'Бордюрна регулация',
        open: false
      },
      regOsLine: {
        strokeColor: {r: 255, g: 179, b: 0, a: 1},
        layerName: 'Осова линия',
        open: false
      },
      selectedPlanType: 'non-edited',
      addChangesOnly: true,
      selectedPlanIsCurrent: true
    }
  }

  setSelectedPlan(feature?: Feature) {
    if (feature) {
      let selectedPlanIsCurrent = false
      if (this.state.locationPlans[0].getProperties()['Id'] == feature.getProperties()['Id']) {
        selectedPlanIsCurrent = true
      }
      const planName = getPlanName(feature)
      this.setState({
        ...this.state,
        selectedPlan: feature,
        parcels: {...this.state.parcels, layerName: 'УПИ: ' + planName},
        quarter: {...this.state.quarter, layerName: 'Квартали: ' + planName},
        selectedPlanIsCurrent
      })
    } else {
      this.setState({
        ...this.state,
        selectedPlan: feature
      })
    }
  }

  setDefaultSelectedPlan() {
    this.setSelectedPlan(
      this.state.locationPlans.find(
        p =>
          (this.state.selectedPlanType == 'edited' && p.getProperties()['RegPlanTypeId'] == 3) ||
          (this.state.selectedPlanType == 'non-edited' && p.getProperties()['RegPlanTypeId'] != 3)
      )
    )
  }

  getPlanTypeSelector() {
    if (this.state.locationPlans.length == 0) return null
    const ops: JSX.Element[] = [
      <option key={1} value={'edited'}>
        Редактирани планове
      </option>,
      <option key={2} value={'non-edited'}>
        Оригинални планове
      </option>
    ]

    return (
      <select
        className="form-control"
        value={this.state.selectedPlanType}
        onChange={e => {
          this.setState({...this.state, selectedPlanType: e.target.value as any}, () => {
            this.setDefaultSelectedPlan()
          })
        }}
      >
        {ops}
      </select>
    )
  }

  getPlanSelector() {
    const ops: JSX.Element[] = []
    this.state.locationPlans.forEach((p, i) => {
      if (this.state.selectedPlanType == 'edited' && p.getProperties()['RegPlanTypeId'] == 3) {
        ops.push(
          <option key={i} value={p.getProperties()['Id']}>
            {getPlanName(p)}
          </option>
        )
      } else if (this.state.selectedPlanType == 'non-edited' && p.getProperties()['RegPlanTypeId'] != 3) {
        ops.push(
          <option key={i} value={p.getProperties()['Id']}>
            {getPlanName(p)}
          </option>
        )
      }
    })
    return (
      <select
        className="form-control"
        value={this.state.selectedPlan ? this.state.selectedPlan.getProperties()['Id'] : ''}
        onChange={e => {
          const selectedPlan = this.state.locationPlans.find(
            p => parseInt(p.getProperties()['Id']) == parseInt(e.target.value)
          )
          this.setSelectedPlan(selectedPlan)
        }}
      >
        {ops}
      </select>
    )
  }

  getVisiblePlans(selectedPlan: Feature): {visible: string[]; nonVisible: string[]} {
    const visiblePlans: string[] = []
    const nonVisible: string[] = []
    this.state.locationPlans.forEach(plan => {
      if (selectedPlan.get('RegPlanTypeId') == 3) {
        const compareDate = new Date(plan.getProperties()['PlanDate'])
        if (plan.get('RegPlanTypeId') != 3) {
          compareDate.setHours(compareDate.getHours() + 6)
        }

        if (compareDate <= new Date(selectedPlan.getProperties()['PlanDate'])) {
          visiblePlans.push(plan.getProperties()['Id'])
        } else {
          nonVisible.push(plan.getProperties()['Id'])
        }
      } else {
        if (new Date(plan.getProperties()['PlanDate']) <= new Date(selectedPlan.getProperties()['PlanDate'])) {
          visiblePlans.push(plan.getProperties()['Id'])
        } else {
          nonVisible.push(plan.getProperties()['Id'])
        }
      }
    })
    return {visible: visiblePlans, nonVisible: nonVisible}
  }

  getWhereClause(visibility: {visible: string[]; nonVisible: string[]}): string {
    const result =
      `"RegPlanId" IN (${visibility.visible.join(',')}) AND ` +
      `(` +
      ` "OverriddenByRegPlanId" IN (${visibility.nonVisible.join(',')}) ` +
      (this.state.addChangesOnly ? '' : `OR "OverriddenByRegPlanId" IS NULL	`) +
      `)`
    return result
  }

  copyRegPlanFeatures(): ISourceDescriptions {
    const sourceDescriptions: ISourceDescriptions = {}
    const visible = this.getVisiblePlans(this.state.selectedPlan!)
    const where = this.getWhereClause(visible)
    for (const id in this.props.layerInfos) {
      const desc = JSON.parse(JSON.stringify(this.props.layerInfos[id].sourceDescription)) as ISourceDescription
      desc.id = desc.id + uuidv4()
      desc.visible = true
      desc.pseudoViewSchema = {0: ViewSchemaType.None, 17: ViewSchemaType.Vector}
      if (appConfig.reg.parcels.parcelsUrl == id) {
        desc.sourceTitle = this.state.parcels.layerName
        desc.readOnly = true
        desc.constantSqlWhere = where
        for (const i in desc.vectorRenderer!.nomenclature!.values) {
          const def = desc.vectorRenderer!.nomenclature!.values[i]!
          def.forEach(s => {
            desc.group = 'Архив'
            if (s.stroke) {
              const stateStrokeColor = this.state.parcels.strokeColor
              s.stroke.color = `rgba(${stateStrokeColor.r},${stateStrokeColor.g},${stateStrokeColor.b},${stateStrokeColor.a})`
            }
            if (s.fill) {
              const fillColor = this.state.parcels.fillColor
              s.fill.color = `rgba(${fillColor.r},${fillColor.g},${fillColor.b},${fillColor.a})`
            }
            if (s.text) {
              const fillColor = this.state.parcels.textColor
              s.text.fillColor = `rgba(${fillColor.r},${fillColor.g},${fillColor.b},${fillColor.a})`
            }
          })
        }

        sourceDescriptions[id] = desc
      } else if (appConfig.reg.quarters.quartersUrl == id) {
        desc.sourceTitle = this.state.quarter.layerName
        desc.readOnly = true
        desc.constantSqlWhere = where
        desc.vectorRenderer!.def!.forEach(s => {
          desc.group = 'Архив'
          if (s.stroke) {
            const stateStrokeColor = this.state.quarter.strokeColor
            s.stroke.color = `rgba(${stateStrokeColor.r},${stateStrokeColor.g},${stateStrokeColor.b},${stateStrokeColor.a})`
          }
          if (s.fill) {
            const fillColor = this.state.quarter.fillColor
            s.fill.color = `rgba(${fillColor.r},${fillColor.g},${fillColor.b},${fillColor.a})`
          }
          if (s.text) {
            const fillColor = this.state.quarter.textColor
            s.text.fillColor = `rgba(${fillColor.r},${fillColor.g},${fillColor.b},${fillColor.a})`
          }
        })
        sourceDescriptions[id] = desc
      } else if (appConfig.reg.regLine.id == id) {
        desc.sourceTitle = this.state.regLine.layerName
        desc.readOnly = true
        desc.constantSqlWhere = where
        desc.vectorRenderer!.def!.forEach(s => {
          desc.group = 'Архив'
          if (s.stroke) {
            const stateStrokeColor = this.state.regLine.strokeColor
            s.stroke.color = `rgba(${stateStrokeColor.r},${stateStrokeColor.g},${stateStrokeColor.b},${stateStrokeColor.a})`
          }
        })
        sourceDescriptions[id] = desc
      } else if (appConfig.reg.regPoint.id == id) {
        desc.sourceTitle = this.state.regPoint.layerName
        desc.readOnly = true
        desc.constantSqlWhere = where
        desc.vectorRenderer!.def!.forEach(s => {
          desc.group = 'Архив'
          if (s.stroke) {
            const stateStrokeColor = this.state.regPoint.strokeColor
            s.stroke.color = `rgba(${stateStrokeColor.r},${stateStrokeColor.g},${stateStrokeColor.b},${stateStrokeColor.a})`
          }
          if (s.circle) {
            if (s.circle.stroke) {
              const stateStrokeColor = this.state.regPoint.strokeColor
              s.circle.stroke.color = `rgba(${stateStrokeColor.r},${stateStrokeColor.g},${stateStrokeColor.b},${stateStrokeColor.a})`
            }
          }
          if (s.text) {
            const stateStrokeColor = this.state.regPoint.strokeColor
            s.text.fillColor = `rgba(${stateStrokeColor.r},${stateStrokeColor.g},${stateStrokeColor.b},${stateStrokeColor.a})`
          }
        })
        sourceDescriptions[id] = desc
      } else if (appConfig.reg.regOsLine.id == id) {
        desc.sourceTitle = this.state.regOsLine.layerName
        desc.readOnly = true
        desc.constantSqlWhere = where
        desc.vectorRenderer!.def!.forEach(s => {
          desc.group = 'Архив'
          if (s.stroke) {
            const stateStrokeColor = this.state.regOsLine.strokeColor
            s.stroke.color = `rgba(${stateStrokeColor.r},${stateStrokeColor.g},${stateStrokeColor.b},${stateStrokeColor.a})`
          }
        })
        sourceDescriptions[id] = desc
      }
    }
    return sourceDescriptions
  }

  getLoactionSelector() {
    return (
      <LocationSelector
        onSettlementsChange={(locs, selectedSettlemet?: Feature, selectedLocation?: Feature) => {
          this.setState(
            {...this.state, selectedLocation: selectedLocation, selectedSettlemet: selectedSettlemet, loading: true},
            () => {
              if (selectedLocation) {
                const planInfo = this.props.layerInfos[appConfig.reg.plan.planUrl]
                ServiceHub.gisCrudService
                  .execute(planInfo, {
                    where: `"LocalityId" = ${selectedLocation.getProperties()['Id']}`,
                    orderByFields: ['PlanDate DESC']
                  })
                  .then(r => {
                    if (r.length > 1) {
                      this.setState({...this.state, locationPlans: r, loading: false}, () => {
                        this.setDefaultSelectedPlan()
                      })
                    } else {
                      this.setState({...this.state, locationPlans: [], loading: false}, () => {
                        this.setSelectedPlan(undefined)
                      })
                    }
                  })
                  .catch(e => {
                    this.setState({...this.state, locationPlans: [], loading: false})
                  })
              } else {
                this.setState({...this.state, locationPlans: [], loading: false})
              }
            }
          )
        }}
        selectedLocation={this.state.selectedLocation}
        selectedSettlemet={this.state.selectedSettlemet}
      />
    )
  }

  getAddPlanOnMapButton() {
    return (
      <>
        <button
          type="button"
          className="button width"
          disabled={!this.state.selectedPlan}
          onClick={() => {
            this.setState({...this.state, exception: '', loading: true, success: ''})
            const sourceDescriotions = this.copyRegPlanFeatures()
            ServiceHub.SourcesService.getInfosFromSources(sourceDescriotions)
              .then(payload => {
                this.props.dispatchSources(payload)
                this.setState({...this.state, exception: '', loading: false, success: 'Успешно добавени'})
              })
              .catch(e => {
                this.setState({...this.state, exception: 'Възникна грешка', loading: false})
              })
          }}
        >
          Добави плана на картата
        </button>
      </>
    )
  }

  getObjectColorPickers(title: string, value: RGBColor, setColor: (color: RGBColor) => void) {
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '10px 0'}}>
        <div style={{width: '100%', textAlign: 'left'}}>{title}</div>
        <div>
          <SliderPicker
            color={value}
            onChange={c => {
              setColor({r: c.rgb.r, g: c.rgb.g, b: c.rgb.b})
            }}
          />
          <AlphaPicker
            color={value}
            onChange={c => {
              setColor(c.rgb)
            }}
          />
        </div>
      </div>
    )
  }

  toggleOpenCollapsible = (contentId: string) => {
    if (contentId == 'parcel') {
      this.setState({...this.state, parcels: {...this.state.parcels, open: !this.state.parcels.open}})
    } else if (contentId == 'quarter') {
      this.setState({...this.state, quarter: {...this.state.quarter, open: !this.state.quarter.open}})
    } else if (contentId == 'regLine') {
      this.setState({...this.state, regLine: {...this.state.regLine, open: !this.state.regLine.open}})
    } else if (contentId == 'regOsLine') {
      this.setState({...this.state, regOsLine: {...this.state.regOsLine, open: !this.state.regOsLine.open}})
    } else if (contentId == 'regPoint') {
      this.setState({...this.state, regPoint: {...this.state.regPoint, open: !this.state.regPoint.open}})
    }
  }

  getColapProps(title: string, contentId: string, open: boolean) {
    return {
      triggerComponent: (
        <div
          style={{
            display: 'flex',
            width: '100%',
            backgroundColor: '#0daada',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 10px'
          }}
        >
          <div className="color-reg-pickers-section-title">{title}</div>
          <div style={{transform: `rotate(${90 * (open ? 1 : 3)}deg)`, fontSize: '25px'}}>{'>'}</div>
        </div>
      ),
      contentId,
      triggerHeight: '45px',
      toggleOpen: this.toggleOpenCollapsible,
      mobile: false,
      height: '340px',
      open
    }
  }

  getParcelColorPickers() {
    return (
      <Collapsible {...this.getColapProps('Парцели', 'parcel', this.state.parcels.open)}>
        <div className="color-reg-pickers-section">
          <div style={{padding: '10px'}}>
            <div style={{display: 'flex'}}>
              <div style={{width: '100%'}}>Име на слоя</div>
              <input
                style={{width: '316px', minWidth: '316px'}}
                className="form-control"
                value={this.state.parcels.layerName}
                onChange={e =>
                  this.setState({...this.state, parcels: {...this.state.parcels, layerName: e.target.value}})
                }
              ></input>
            </div>
            {this.getObjectColorPickers('Линия', this.state.parcels.strokeColor, (rgb: RGBColor) => {
              this.setState({
                ...this.state,
                parcels: {...this.state.parcels, strokeColor: {...this.state.parcels.strokeColor, ...rgb}}
              })
            })}
            {this.getObjectColorPickers('Запълване', this.state.parcels.fillColor, (rgb: RGBColor) =>
              this.setState({
                ...this.state,
                parcels: {...this.state.parcels, fillColor: {...this.state.parcels.fillColor, ...rgb}}
              })
            )}
            {this.getObjectColorPickers('Цвят на текста', this.state.parcels.textColor, (rgb: RGBColor) =>
              this.setState({
                ...this.state,
                parcels: {...this.state.parcels, textColor: {...this.state.parcels.textColor, ...rgb}}
              })
            )}
          </div>
        </div>
      </Collapsible>
    )
  }

  getQuarterColorPickers() {
    return (
      <Collapsible {...this.getColapProps('Квартали', 'quarter', this.state.quarter.open)}>
        <div className="color-reg-pickers-section">
          <div style={{padding: '10px'}}>
            <div style={{display: 'flex'}}>
              <div style={{width: '100%'}}>Име на слоя</div>
              <input
                style={{width: '316px', minWidth: '316px'}}
                className="form-control"
                value={this.state.quarter.layerName}
                onChange={e =>
                  this.setState({...this.state, quarter: {...this.state.quarter, layerName: e.target.value}})
                }
              ></input>
            </div>
            {this.getObjectColorPickers('Линия', this.state.quarter.strokeColor, (rgb: RGBColor) =>
              this.setState({
                ...this.state,
                quarter: {...this.state.quarter, strokeColor: {...this.state.quarter.strokeColor, ...rgb}}
              })
            )}
            {this.getObjectColorPickers('Запълване', this.state.quarter.fillColor, (rgb: RGBColor) =>
              this.setState({
                ...this.state,
                quarter: {...this.state.quarter, fillColor: {...this.state.quarter.fillColor, ...rgb}}
              })
            )}
            {this.getObjectColorPickers('Цвят на текста', this.state.quarter.textColor, (rgb: RGBColor) =>
              this.setState({
                ...this.state,
                quarter: {...this.state.quarter, textColor: {...this.state.quarter.textColor, ...rgb}}
              })
            )}
          </div>
        </div>
      </Collapsible>
    )
  }
  getRegLineColorPickers() {
    return (
      <Collapsible {...this.getColapProps('Бордюрна регулация', 'regLine', this.state.regLine.open)}>
        <div className="color-reg-pickers-section">
          <div style={{padding: '10px'}}>
            <div style={{display: 'flex'}}>
              <div style={{width: '100%'}}>Име на слоя</div>
              <input
                style={{width: '316px', minWidth: '316px'}}
                className="form-control"
                value={this.state.regLine.layerName}
                onChange={e =>
                  this.setState({...this.state, regLine: {...this.state.regLine, layerName: e.target.value}})
                }
              ></input>
            </div>
            {this.getObjectColorPickers('Линия', this.state.regLine.strokeColor, (rgb: RGBColor) =>
              this.setState({
                ...this.state,
                regLine: {...this.state.regLine, strokeColor: {...this.state.regLine.strokeColor, ...rgb}}
              })
            )}
          </div>
        </div>
      </Collapsible>
    )
  }
  getRegOsLineColorPickers() {
    return (
      <Collapsible {...this.getColapProps('Осова линия', 'regOsLine', this.state.regOsLine.open)}>
        <div className="color-reg-pickers-section">
          <div style={{padding: '10px'}}>
            <div style={{display: 'flex'}}>
              <div style={{width: '100%'}}>Име на слоя</div>
              <input
                style={{width: '316px', minWidth: '316px'}}
                className="form-control"
                value={this.state.regOsLine.layerName}
                onChange={e =>
                  this.setState({...this.state, regOsLine: {...this.state.regOsLine, layerName: e.target.value}})
                }
              ></input>
            </div>
            {this.getObjectColorPickers('Линия', this.state.regOsLine.strokeColor, (rgb: RGBColor) =>
              this.setState({
                ...this.state,
                regOsLine: {...this.state.regOsLine, strokeColor: {...this.state.regOsLine.strokeColor, ...rgb}}
              })
            )}
          </div>
        </div>
      </Collapsible>
    )
  }
  getRegPointColorPickers() {
    return (
      <Collapsible {...this.getColapProps('Осова точка', 'regPoint', this.state.regPoint.open)}>
        <div className="color-reg-pickers-section">
          <div style={{padding: '10px'}}>
            <div style={{display: 'flex'}}>
              <div style={{width: '100%'}}>Име на слоя</div>
              <input
                style={{width: '316px', minWidth: '316px'}}
                className="form-control"
                value={this.state.regPoint.layerName}
                onChange={e =>
                  this.setState({...this.state, regPoint: {...this.state.regPoint, layerName: e.target.value}})
                }
              ></input>
            </div>
            {this.getObjectColorPickers('Цвят', this.state.regPoint.strokeColor, (rgb: RGBColor) =>
              this.setState({
                ...this.state,
                regPoint: {...this.state.regPoint, strokeColor: {...this.state.regPoint.strokeColor, ...rgb}}
              })
            )}
          </div>
        </div>
      </Collapsible>
    )
  }
  getColoPickers() {
    return (
      <div>
        <h3>Симвология на историята</h3>
        {this.getParcelColorPickers()}
        {this.getQuarterColorPickers()}
        {this.getRegLineColorPickers()}
        {this.getRegOsLineColorPickers()}
        {this.getRegPointColorPickers()}
      </div>
    )
  }

  getArchiveButton() {
    return (
      <div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div>Архив</div>
          <div
            style={{
              padding: '10px 0',
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <button
              type="button"
              className="button width"
              onClick={() => {
                window.location.replace('/archive')
              }}
            >
              Документален Архив
            </button>
          </div>
        </div>
      </div>
    )
  }

  getProjectionSelector(): JSX.Element {
    return (
      <CsSelectorLite
        className="form-control"
        selected={this.state.exportCs}
        onChange={s => {
          this.setState({...this.state, exportCs: s})
        }}
      />
    )
  }

  getExportPlanAsDxf() {
    return this.props.user && (this.props.user.isAdmin || this.props.user.isRegAdmin) ? (
      <div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div>Експорт</div>
          <div
            style={{
              padding: '10px 0',
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}
          >
            {this.getProjectionSelector()}
            <button
              type="button"
              className="button width"
              disabled={!this.state.selectedPlan}
              onClick={() => {
                this.setState({...this.state, exception: '', success: '', loading: true})
                Axios.post(appConfig.urls.xyApiUrl + '/ExportPlan', {
                  DestinationCS: this.state.exportCs,
                  PlanId: this.state.selectedPlan!.getProperties()['Id'],
                  Differences: false //this.state.addChangesOnly
                })
                  .then(r => {
                    this.setState({
                      ...this.state,
                      exception: '',
                      success: 'Успешен експорт',
                      exportedPlan: appConfig.urls.xyApiUrl + '/' + r.data.PATH,
                      loading: false
                    })
                  })
                  .catch(() => {
                    this.setState({...this.state, exception: 'Възникна грешка', success: '', loading: false})
                  })
              }}
            >
              DXF
            </button>
            <button
              type="button"
              className="button width"
              disabled={!this.state.selectedPlan}
              onClick={() => {
                this.setState({...this.state, exception: '', success: '', loading: true})
                Axios.get(
                  appConfig.urls.xyApiUrl + '/cad-export?planId=' + this.state.selectedPlan!.getProperties()['Id']
                )
                  .then(r => {
                    this.setState({
                      ...this.state,
                      exception: '',
                      success: 'Успешен експорт',
                      exportedPlan: appConfig.urls.xyApiUrl + '/' + r.data.PATH,
                      loading: false
                    })
                  })
                  .catch(() => {
                    this.setState({...this.state, exception: 'Възникна грешка', success: '', loading: false})
                  })
              }}
            >
              CAD4
            </button>
            {/* <button type="button" onClick={() => navigate("/archive")}>Go Back One</button> */}
          </div>
        </div>
        {this.state.exportedPlan ? (
          <div style={{padding: '10px'}}>
            <a href={this.state.exportedPlan} target="_blank" style={{wordBreak: 'break-all'}} rel="noreferrer">
              {this.state.exportedPlan}
            </a>
          </div>
        ) : null}
      </div>
    ) : null
  }

  protected getPlanActions(selectedPlan: Feature) {
    if (this.state.selectedPlanIsCurrent) {
      return <h3 style={{textAlign: 'center'}}>Това е актуалният план!</h3>
    }
    return (
      <React.Fragment>
        {this.getColoPickers()}
        {this.getAddChangesOnlyCheckbox()}
        {this.getAddPlanOnMapButton()}
        <br></br>
      </React.Fragment>
    )
  }

  getAddChangesOnlyCheckbox() {
    return (
      <div style={{display: 'flex', height: '30px', alignItems: 'center'}}>
        <div style={{}}>Само разлики</div>
        <input
          style={{width: '316px', transform: 'scale(1.5)'}}
          type="checkbox"
          checked={this.state.addChangesOnly}
          onChange={() => this.setState({...this.state, addChangesOnly: !this.state.addChangesOnly})}
        ></input>
      </div>
    )
  }

  render() {
    return (
      <div className="reg-history">
        <OverlayLoader show={this.state.loading}></OverlayLoader>
        {this.getLoactionSelector()}
        <br></br>
        {this.getPlanTypeSelector()}
        <br></br>
        {this.getPlanSelector()}
        <div style={{position: 'relative'}}>
          <OverlayLoader show={this.state.loading}></OverlayLoader>
          <br></br>
          {this.state.selectedPlan ? this.getPlanActions(this.state.selectedPlan) : null}

          {this.getExportPlanAsDxf()}
          {this.getArchiveButton()}
          {this.state.exception &&
          this.state.exception != this.confirmDeleteMsg &&
          this.state.exception != this.confirmDeleteLocMsg &&
          this.state.exception != this.confirmDeletePlanMsg ? (
            <div className="error-div">{this.state.exception}</div>
          ) : null}
          {this.state.success ? <div className="success-div">{this.state.success}</div> : null}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: IAppStore) => {
  return {
    layerInfos: state.layerInfos.featureLayerInfos,
    user: state.userInfo.user
  }
}
//<OwnProps, DispatchProps, ParentProps>
export const RegHistory = connect(mapStateToProps, {
  ...appSourcesDispatcher
})(RegHistoryClass)
